import React, { useEffect, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Box, Boxes } from '../../../layout/box'
import { BigButton } from '../../../../../components/button'
import withStripe from './hocs/stripe'
import Paying from '../components/loading/paying'

import {
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement,
} from '@stripe/react-stripe-js'
import { FormattedMessage } from 'react-intl'
import AskMask from '../components/ask-mask'

const ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: '12px',
            color: '#424770',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#9e2146',
        },
    },
}

const CardBody = withStripe(props => {
    useStyles(classes)

    const [ready, setReady] = useState(false)

    const {
        children,
        elements,
        cardError,
        expiryError,
        cvvError,
        submiting,
        handleCardError,
        handleExpiryError,
        handleCvvError,
        showNew
    } = props


    const handleSubmit = async e => {
        e.preventDefault()
        props.handleSumbit(e, elements)
    }

    useEffect(() => {
        setReady(true)
    }, [])
    

    return <>
        <form onSubmit={handleSubmit}>
            {
                showNew && <Boxes>
                    <Box className={classes.CreditBody}>
                        <div className={classes.CardContainer}>
                            <div className={classes.CardHolder}>
                                <label className={classes.Label}>*<FormattedMessage id="card_number" defaultMessage={'Card NUmber'}/></label>
                                <CardNumberElement
                                    id="cardNumber"
                                    options={ELEMENT_OPTIONS}
                                    onChange={handleCardError}
                                />
                                <div className={classes.Error}>
                                    {cardError}
                                </div>
                            </div>

                            <div className={classes.MultiHolders}>

                                <div className={classes.CardHolder}>
                                    <label className={classes.Label}>*<FormattedMessage id="expiration_date" defaultMessage={'Expiration_date'}/></label>
                                    <CardExpiryElement
                                        id="expiry"
                                        options={ELEMENT_OPTIONS}
                                        onChange={handleExpiryError}
                                    />
                                    <div className={classes.Error}>
                                        {expiryError}
                                    </div>
                                </div>

                                <div className={classes.CardHolder}>
                                    <label className={classes.Label}>
                                        *Cvv
                                        <AskMask/>
                                    </label>
                                    <CardCvcElement
                                        id="cvc"
                                        options={ELEMENT_OPTIONS}
                                        onChange={handleCvvError}
                                    />
                                    <div className={classes.Error}>
                                        {cvvError}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Box>
                </Boxes>
            }

            {
                children
            }
            <div className={classes.PayBtn}>
                <BigButton disabled={!ready} loading={submiting} type="submit"><FormattedMessage id="pay_now" defaultMessage={'Pay Now'}/></BigButton>
            </div>
        </form>

        {
            submiting && <Paying/>
        }
    </>
})




export default CardBody